import Vue from 'vue'

Vue.filter('formatPrice', price => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
})

Vue.filter('formatPhone', phone => {
    let formatted = phone.match(/(\d{3})(\d{2})(\d{3})(\d{2})(\d{2})/)
    if (!formatted) {
        return phone
    }
    return `+(${formatted[1]}) ${formatted[2]} ${formatted[3]} ${formatted[4]} ${formatted[5]}`
})

Vue.filter('formatDate', date => {
    const bookingDate = new Date(date)
    const months = ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря']

    return `${bookingDate.getDate()} ${months[bookingDate.getMonth()]}, ${bookingDate.getFullYear()}г.`
})

Vue.filter('formatTime', time => {
    const bookingTime = new Date(time)

    return `${(bookingTime.getHours() < 10) ? '0' + bookingTime.getHours() : bookingTime.getHours()}:${(bookingTime.getMinutes() < 10) ? '0' + bookingTime.getMinutes() : bookingTime.getMinutes()}`
})

Vue.filter('formatPlatform', platform => {
    let txt

    switch (platform) {
        case 1:
            txt = 'Моб.приложение'
            break
        case 2:
            txt = 'Telegram бот'
            break
        default:
            txt = 'Сайт'
            break
    }

    return txt
})

Vue.filter('formatHall', hall => {
    let txt = ''

    switch (hall) {
        case 1:
            txt = 'Для курящих'
            break
        case 2:
            txt = 'Для некурящих'
            break
        case 3:
            txt = 'Детский'
            break
        case 4:
            txt = 'Терасса'
            break
        case 5:
            txt = 'Общий'
            break
        default:
            txt = 'Неизвестно'
            break
    }

    return txt
})

Vue.filter('formatPayment', payment => {
    let txt = ''

    switch (payment) {
        case 1:
            txt = 'Наличные'
            break
        case 2:
            txt = 'Click'
            break
        case 3:
            txt = 'Payme'
            break
        default:
            txt = 'Неизвестно'
            break
    }

    return txt
})

Vue.filter('formatDelivery', delivery => {
    let txt = ''

    switch (delivery) {
        case 1:
            txt = 'Самовывоз'
            break
        case 2:
            txt = 'Доставка от заведения'
            break
        default:
            txt = 'Неизвестно'
            break
    }

    return txt
})

Vue.filter('removeAllExpectNumbers', value => {
    return value.toString().replace(/[!@#$%^&*]/g, '')
})
